import React from 'react';
import {Currency, formatNumberCurrency, Locale} from "../../../helpers/Formatting";
import {ViewIdentifier} from "../../../models/common/ViewSettings";
import {TextDisplay, TextDisplayProps} from "./TextDisplay";


interface MoneyDisplayProps extends TextDisplayProps {
    value: number
    /** the currency symbol to be used, default to EURO */
    currency?: Currency
    /** the locale the money value is formatted to, defaults to de-DE */
    locale?: Locale
    style?: React.CSSProperties
    className?: string
    /** when set, displays the value as is. defaults to false */
    shouldNotFormat?: boolean,
    identifier?: ViewIdentifier
}

/**
 * Displays the given value as formatted text
 * Text is passed to the TextDisplay component
 *
 * Component uses Number.toLocaleString function.
 * All currencies and locals that are legal in that function are legal here
 */
export function MoneyDisplay( props: MoneyDisplayProps ) {

    const { value } = props;
    const localeToFormat = props.locale || Locale.GERMANY;

    let text = (  props.shouldNotFormat) ?  props.value : formatNumberCurrency( value.toString(), props.currency || Currency.EURO, localeToFormat );


    return (
        <TextDisplay align='right' { ...props }>{ text }</TextDisplay>
    );
}